export default "__VITE_ASSET__f038363b__"